var CollectionView = require('views/base/collection-view');

var QuestionCollectionView = CollectionView.extend({
  initItemView: function(model) {
    return new this.itemView({
      autoRender: false,
      noWrap: false,
      model: model
    });
  },
  itemView: require('./question-view'),
  template: require('./templates/question-collection'),
  listSelector: '.questions',
  autoRender: true
});

module.exports = QuestionCollectionView;
